import { AnalyticsBrowser } from '@segment/analytics-next'

import analyticsService from './analyticsService'

export default {
  install(app, { segmentKey, vueRouter }) {
    if (!segmentKey) {
      console.error('[Segment] Segment API write key is required')
      return
    }

    const segmentAnalytics = AnalyticsBrowser.load({ writeKey: segmentKey })

    const analytics = analyticsService(segmentAnalytics, vueRouter)

    app.config.globalProperties.$analytics = analytics
  },
}
